export default "__VITE_ASSET__CWzjqfXi__"